import React from "react";

export const formatCOP = (n) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency", currency: "COP", maximumFractionDigits: 0,
  }).format(Number(n || 0));

export const StatusBadge = ({ status }) => {
  const map = {
    activo: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    pausado: "bg-amber-500/10 text-amber-400 border-amber-500/20",
    finalizado: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
    cobrada: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    pendiente: "bg-amber-500/10 text-amber-400 border-amber-500/20",
    emitida: "bg-sky-500/10 text-sky-400 border-sky-500/20",
    vencida: "bg-red-500/10 text-red-400 border-red-500/20",
    programada: "bg-[#F97316]/10 text-[#F97316] border-[#F97316]/20",
    realizada: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    cancelada: "bg-red-500/10 text-red-400 border-red-500/20",
    borrador: "bg-zinc-500/10 text-zinc-300 border-zinc-500/20",
    enviada: "bg-sky-500/10 text-sky-400 border-sky-500/20",
    enviado: "bg-sky-500/10 text-sky-400 border-sky-500/20",
    aprobada: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    rechazada: "bg-red-500/10 text-red-400 border-red-500/20",
    firmado: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  };
  const cls = map[status] || "bg-zinc-500/10 text-zinc-400 border-zinc-500/20";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-medium capitalize ${cls}`}>
      {status}
    </span>
  );
};

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex items-start justify-between mb-8 gap-4 flex-wrap">
    <div>
      <h1 className="text-3xl md:text-4xl font-bold text-[#F5F5F7] tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }}>
        {title}
      </h1>
      {subtitle && <p className="text-[#9CA3AF] mt-1 text-sm">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="bg-[#15171E] border border-[#262A33] rounded-2xl p-12 text-center flex flex-col items-center">
    {Icon && (
      <div className="w-14 h-14 rounded-2xl bg-[#F97316]/10 flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-[#F97316]" strokeWidth={1.75} />
      </div>
    )}
    <h3 className="text-lg font-bold text-[#F5F5F7] mb-1" style={{ fontFamily: "Manrope, sans-serif" }}>{title}</h3>
    {description && <p className="text-[#9CA3AF] text-sm mb-6 max-w-md">{description}</p>}
    {action}
  </div>
);

export const PrimaryButton = React.forwardRef(({ children, className = "", ...props }, ref) => (
  <button
    ref={ref}
    {...props}
    className={`inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold rounded-xl px-4 py-2.5 text-sm transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
));
PrimaryButton.displayName = "PrimaryButton";

export const GhostButton = React.forwardRef(({ children, className = "", ...props }, ref) => (
  <button
    ref={ref}
    {...props}
    className={`inline-flex items-center gap-2 bg-transparent border border-[#262A33] hover:bg-[#1A1D24] text-[#F5F5F7] font-medium rounded-xl px-3 py-2 text-sm transition-colors duration-200 ${className}`}
  >
    {children}
  </button>
));
GhostButton.displayName = "GhostButton";

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="block text-xs font-medium text-[#9CA3AF] mb-1.5">{label}</span>
    {children}
    {hint && <span className="block text-[11px] text-[#6B7280] mt-1">{hint}</span>}
  </label>
);

export const inputCls =
  "w-full bg-[#0B0D12] border border-[#262A33] rounded-xl px-3 py-2.5 text-sm text-[#F5F5F7] placeholder:text-[#6B7280] focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-transparent transition-colors";
